import { ConnectionLineType, MarkerType } from '@xyflow/react';

import { NotableEdge } from './Edge';
import { ErrorEdge } from './ErrorEdge';

export const DEFAULT_EDGE_TYPE = 'notableEdge';
export const ERROR_EDGE_TYPE = 'notableErrorEdge';

export const DEFAULT_EDGE_PROPS = {
  markerEnd: {
    type: MarkerType.Arrow,
    width: 16,
    height: 16,
    color: '#BFBFBF',
  },
};

export const CONNECTION_EDGE_PROPS = {
  ...DEFAULT_EDGE_PROPS,
  style: {
    stroke: '#BFBFBF',
    strokeWidth: 2,
  },
  /**
   * This is necessary to prevent the edge from being drawn over the card when the user is dragging a node.
   * See: https://www.loom.com/share/5c9b60a3fd9542f6b7e279c50fb7af3b
   */
  type: ConnectionLineType.Bezier,
};

export const STANDARD_EDGE_TYPES = {
  [DEFAULT_EDGE_TYPE]: NotableEdge,
  [ERROR_EDGE_TYPE]: ErrorEdge,
};
